import ReactGA from "react-ga";
import mixpanel from "mixpanel-browser";
import {
  getCurrentUserAttr,
  UserAttrs,
} from "user-management/src/cognito/kahunUserAuth";
import { isLocal } from "fe-common/utils/envGetter";
import { getFeatureFlags } from "fe-common/featureFlags/getFeatureFlags";
import { writeToGlobalStorage } from "fe-web-components/userStorage/globalUserStorage";
import { UserStorageKey } from "fe-web-components/userStorage/userStorageKey";

export enum CATEGORY {
  NAVIGATION = "Navigation",
  SELECTION = "Selection",
  SEARCH = "Search",
  GRAPH = "Graph",
  AGENT_MAIN = " Main",
  AGENT_WIZARD = "Agent Wizard",
  REFINE_POPUP = "Refine Popup",
  EDIT_PANEL_POPUP = "Edit Panel Popup",
  AGENT_PATIENT_VIEW = "Agent Patient view",
  AGENT_DISEASE_CARD = "Agent Disease Card",
  AGENT_DD_LIST = "Agent DD List",
  COVID_CALCULATOR = "Covid Calculator",
  AGENT_DIAGNOSE = "DD",
  EXPANDED_DISEASE = "Mobile expanded disease",
  IMPROVE_DIAGNOSIS = "Improve DD",
  PLAN = "Plan",
  TERMS_OF_SERVICE = "Terms of Service",
  AGENT = "Agent",
  PANELS = "Panel",
  DD_STATUS = "DD Status",
  WELCOME_SCREEN = "Welcome screen",
  GENERAL_UX = "General",
  NAVIGATION_MENU = "Navigation Menu",
  PWA_INSTALL_WINDOW = "PWA Install Window",
  USER_MANAGEMENT_POPUP = "User management popup",
  MINI_DISEASE = "Mini disease",
  NEW_VERSION_POPOVER = "New version popover",
  INSTALL_APP_POPOVER = "Install app window",
  WELCOME_BACK_PAGE = "Welcome back",
  PATIENT_CHAT = "Chat",
  PATIENT_RESULT = "Results",
  PATIENT_THANKS = "Thanks",
  PATIENT_INIT = "Initial",
  PATIENT_GENERAL = "Patient",
  CLINIC_MANAGEMENT = "Clinic Management",
  USER_AUTHENTICATION = "User authentication",
  USER_FEEDBACK = "Patient feedback",
  EHR_ADDON = "Ehr Addon",
  PATIENT_CARD = "Patient Card",
}

export enum ACTION {
  AGREE_TERMS = "Agree on Terms",
  DISAGREE_TERMS = "Disagree on Terms",
  SESSION_INIT = "Start Session",
  RESET = "Reset",
  TAB_CLICK = "Tab Click",
  USER_SEND_ERROR_FEEDBACK = "User Send Error Feedback",
  DD_ERROR = "DD Error - Empty Diseases List due to technical issue",
  DD_INSUFFICIENT_DATA = "DD Error - Empty Diseases List due to insufficient data",
  MAIN_TAB_CLICK = "Main Tab Click",
  SELECT_FEATURE = "Select feature",
  ADD_FINDING_CHIP_DD = "Add finding chip",
  REFINE_POPUP_DONE = "Click Done",
  REFINE_POPUP_CANCEL = "Click Cancel",
  EDIT_PANEL_POPUP_DONE = "Click Done",
  REFINE_POPUP_DELETE = "Click Delete",
  RESET_PLAN = "Reset Plan",
  SHOW_GRAPH = "Show Graph",
  SHOW_REFERENCES = "Show References",
  EXPLORE_DISEASE = "Explore",
  NEGATE_FINDING = "Negate Finding",
  MAKE_FINDING_POSITIVE = "Make Finding Positive",
  ADD_FINDING_TO_PLAN = "Add finding to Plan",
  REMOVE_FINDING_FROM_PLAN = "Remove finding from Plan",
  PLAN_SHOW_MORE = "Show More in plan",
  PLAN_SHOW_LESS = "Show Less in plan",
  DONE_IMPROVE_DIAGNOSIS = "Done Improve Diagnosis",
  CLOSE_IMPROVE_DIAGNOSIS = "Close Improve Diagnosis",
  SHOW_CLINICAL_REASONING = "Show Clinical Finding",
  HIDE_CLINICAL_REASONING = "Hide Clinical Finding",
  SELECT_FINDING_SEARCH = "Select finding search",
  SELECT_DISEASE = "Select Disease",
  REMOVE_FINDING_CHIP = "Remove finding chip",
  TYPE = "Type",
  NODE = "Node",
  EDGE = "Edge",
  LINK = "Link",
  SELECT_CHIEF_COMPLAINT = "Select chief complaint",
  SELECT_AGE = "Select age",
  SELECT_GENDER = "Select gender",
  DIAGNOSE = "Diagnose",
  START = "Start",
  OPEN_RESOURCES = "Open resources",
  CLOSE_RESOURCES = "Close resources",
  UPDATE_PATIENT_CASE = "Update patient case",
  BACK = "Back",
  SELECT_TAB_SUBGROUP = "Select tab subgroup",
  SELECT_MINI_DISEASE_TAB = "Select Mini Disease tab",
  SELECT_FEATURE_FROM_TAB_SEARCH = "Select feature Tab Search",
  SELECT_FEATURE_FROM_TAB_SUGGESTED = "Select feature tab suggested",
  EXPAND_DISEASE = "Expand disease",
  COLLAPSE_DISEASE = "Collapse disease",
  START_OVER_BUTTON_CLICKED = "Start over button clicked",
  START_OVER_OPEN_DIALOG = "Start Over Open Dialog",
  START_OVER_APPLIED = "Start Over Applied",
  START_OVER_DIALOG_CANCEL = "Start Over Dialog - Cancel",
  MISMATCH_CASE_CONTINUE = "mismatch case - continue",
  EXPAND_PATIENT = "Expand Patient",
  COLLAPSE_PATIENT = "Collapse Patient",
  OPEN_NEXT_STEP = "Open Next Step",
  CLOSE_NEXT_STEP = "Close Next Step",
  CLICK_MORE_INFO = "Click more Info",
  SHOW_MORE = "Show more",
  SHOW_LESS = "Show less",
  CANCEL = "Cancel",
  SELECT_SUBTYPE = "Select sub type",
  REMOVE_SUBTYPE = "Remove sub type",
  CLICK_REFINE = "Click refine",
  ADD_REFINE = "Add refine",
  REMOVE_REFINE = "Remove refine",
  CHECK_ALL_NORMAL = "Check All Normal",
  UNCHECK_ALL_NORMAL = "Uncheck All Normal",
  ASSESSMENT_HELPFUL = "Assessment Helpful",
  ASSESSMENT_NOT_HELPFUL = "Assessment Not Helpful",
  LIKE_DISEASE = "Like Disease",
  DISLIKE_DISEASE = "Dislike Disease",
  CLICK_PROCEDURES_SELECT_ABNORMAL = "Select Abnormal",
  CALCULATE = "Calculate",
  OPEN_IMPROVE_DIAGNOSIS = "Open Improve Diagnosis",
  SHOW_PLAN = "Show Plan",
  GO_TO_PATIENT = "Go To Patient",
  GO_TO_DIAGNOSIS = "Go To Diagnosis",
  GO_TO_PLAN = "Go To Plan",
  INIT = "INIT",
  NEXT_STEP_ACCEPT = "Next Step Accept",
  NEXT_STEP_SKIP = "Next Step Skip",
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
  SORT_TYPE = "Sort Type",
  RESTORE_CASE = "Open shared case",
  SHARE_CASE = "Share case",
  OPEN_CASE = "Open shared case from my cases",
  SAVE_CASE = "Save Case",
  WIZARD_COMPLETE = "Wizard Completed",
  WIZARD_COMPLETE_NTH = "Wizard Completed NTH",
  ADD_DISEASE_TO_PLAN = "Add disease to plan",
  REMOVE_DISEASE_FROM_PLAN = "Remove disease from plan",
  ADD_DISEASE_FROM_SEARCH = "Searched for disease",
  OPEN_ADD_DISEASE_SEARCH = "Open add disease search",
  CLOSE_DISEASE_SEARCH = "Close add disease search without selecting disease",
  OPEN_DISEASE_MENU = "Disease menu open",
  OPEN_DD_ACTIONS_MENU = "DD Actions menu open",
  PANEL_SEARCH_OPEN = "Open panel search",
  PANEL_SEARCH_CLOSE = "Close panel search",
  PANEL_SEARCH_ITEM_SELECTED = "Search item selected",
  PANEL_SEARCH_REFINE = "Panel search refine option",
  SEND_FEEDBACK = "Send feedback",
  SIGN_UP = "Sign up",
  SIGN_UP_FAILED = "Sign up failed",
  LOG_IN = "Log in",
  SPECIALTY_SELECTED = "Selected specialty",
  NEW_SERVICE_WORKER_RELOAD = "Case restored after version update",
  EXPORT_DATA_CLICKED = "Open export data desktop",
  EXPORT_DATA_CLICKED_MOBILE = "Open export data mobile",
  EXPORT_DATA_CLICKED_DROP_DOWN = "Open export data mobile drop down",
  COPY_EXPORT_DATA_CLICKED = "Copy export data",
  SECTION_ACTION_CLICKED = "Section Action clicked",
  PRINT_EXPORT_DATA_CLICKED = "Print export data",
  SEND_TO_EHR_CLICKED = "Send Data to EHR",
  USER_INSTALLED_PWA_RESULT = "User Installed PWA",
  USER_REJECTED_PWA_INSTALL = "User rejected PWA install",
  USER_CLICKED_PWA_FROM_MENU = "User clicked Install PWA from drawer menu",
  USER_MANAGEMENT_POPUP_STATE_CHANGED = "User managaement popup state changed",
  UPDATE = "Update",
  CLOSE = "Close",
  DISPLAYED = "Displayed",
  USER_CLOSED_INSTALL_APP_WINDOW = "User closed install app window",
  USER_CLICKED_STORE_LINK_WINDOW = "User clicked on store icon",
  OPEN_LAST_CASE = "Opened last case",
  NAVIGATED_TO_SAVED_CASES = "User went to saved cases",
  NAVIGATED_TO_HOW_IT_WORKS = "User clicked on `how kahun works`",
  CHANGE_LOCALE = "Locale was changed",
  /*********          v--- PATIENT 1st ACTIONS ---v           *****************/
  PATIENT_PAGE_LOAD = "Loaded page",
  PATIENT_FINAL_QUESTION = "Final Question",
  PATIENT_SHOW_DESCRIPTION = "Show Description",
  PATIENT_BUTTON_CLICKED = "Clicked on button",
  PATIENT_SAVED_CONVERSATION = "Conversation saved",
  PATIENT_ANSWERED_QUESTION = "Question answered",
  PATIENT_CLICKED_DISEASE = "Disease clicked",
  PATIENT_CLICKED_MORE_INFO = "More Info clicked",
  PATIENT_CLICKED_COVID_DISCLAIMER = "Covid disclaimer clicked",
  PATIENT_UNDONE_ANSWER = "Undo question answered",
  PATIENT_ERROR = "ERROR",
  PATIENT_CANT_FIND_SYMPTOM = "Can't find a symptom?",
  PATIENT_ADD_FREE_TEXT = "Add free text",
  PATIENT_SEND_FEEDBACK = "Patient Send Feedback",
  PATIENT_DISMISS_FEEDBACK = "Patient Dismissed Feedback",
  PATIENT_SET_FEEDBACK_SCORE = "Patient changed feedback score",
  PATIENT_WHATS_NEXT = "Patient what's next",
  PATIENT_Q_REASONING_CLICK = "DEMO - click on demo icon",
  PATIENT_Q_REASONING = "DEMO - Reasoning",
  PATIENT_Q_REFERENCES = "DEMO - Reasoning",
  PATIENT_Q_DISEASE_INFO = "DEMO - Reasoning disease Info",
  PATIENT_FINISH_CONVERSATION = "Conversation finished",
  PATIENT_SKIPPED_CONVERSATION = "Conversation skipped",
  /*********          v--- Clinit Managment ACTIONS ---v           *****************/
  CLINIC_CREATED = "Clinic created",
  CLINIC_OPEN_PATIENT_CARD = "Opened patient card",
  CLINIC_CLOSED_PATIENT_CARD = "Closed patient card",
  ADD_USER_TO_CLINIC_REQUEST = "User asked to join a clinic",
  CLINIC_PATIENT_PROVIDER_LINK = "Opened Provider's link",
  CLINIC_INVITE_SENT = "Patient invitation sent",
  CLINIC_COPY_PATIENT_SUMMARY = "Copy summary",
  CLINIC_OPEN_PATIENT_IN_AGENT = "Open Agent",
  CLINIC_ADD_DOCTOR_NOTE_ON_PATIENT = "Add Note",
  CLINIC_ADD_CLINIC_USER = "Invite user",
  CLINIC_REMOVE_CLINIC_USER = "Remove user",
  CLINIC_NUMBER_OF_INVITES = "# of invites",
  CLINIC_SAVE_CUSTOM_CHANGES = "Save custom changes",
  CLINIC_HELP_CLICKED = "Help clicked",
  CLINIC_FILTERED = "Filter patients",
  CLINIC_SEARCHED = "Search patients",
  CLINIC_STARTED_REGISTRATION = "Start Clinic registration",
  /*********          v--- Addon  ACTIONS ---v           *****************/
  ADDON_GENERAL_ACTION = "General event",
  ADDON_INIT = "Init",
  ADDON_OPENED = "Add-on opened",
  ADDON_CLOSED = "Add-on closed",
  ADDON_RIGHT_MENU_OPEN = "Right menu clicked",
  ADDON_RIGHT_MENU_OPTION = "Right Menu item clicked -",
  ADDON_CASE_LOADED = "Cases loaded in EHR",
}

const reportFacebookPixel = getFeatureFlags("reportFacebookPixel");
const reportLinkedPixel = getFeatureFlags("reportLinkedPixel");

const nonPrivateActions = [ACTION.PATIENT_PAGE_LOAD, ACTION.SESSION_INIT];

let pendingUserForAnalytics = null;
let pendingEvts: { evtAsStr: string; props: object }[] = [];
export let mixpanel_distinct_id: string;
let _privateMode = false;

export const initAnalytics = (
  [googleKey, mixPanelKey],
  debug = false,
): void => {
  try {
    mixpanel.init(mixPanelKey, {
      debug: debug || getFeatureFlags("debugSheet"),
      ignore_dnt: debug || getFeatureFlags("debugSheet"),

      loaded: (mixpanel) => {
        mixpanel_distinct_id = mixpanel.get_distinct_id();
      },
    });

    if (googleKey) {
      ReactGA.initialize(googleKey);
      ReactGA.pageview(window.location.pathname + window.location.search);
    }
  } catch (e) {
    console.error(e?.message);
  }
};

/*
 * mixPanelStartFromEvts - array of events for which we start reporting.
 * This is used to deacrease the number of users in mixPanel, and report only relevant users
 * Once one of the events is reported the user is created and all the previous events are reported*/
export const setUserForAnalytics = (
  user: string = null,
  props = {},
  mixPanelStartFromEvts: { category: CATEGORY; action: ACTION }[] = null,
  privateMode = false, //remove label from the events - keep only generic actions
) => {
  _privateMode = privateMode;
  if (mixPanelStartFromEvts && mixPanelStartFromEvts.length) {
    pendingUserForAnalytics = {
      user,
      props,
      mixPanelStartFromEvts,
    };
  } else {
    if (user) {
      mixpanel.identify(user);
      mixpanel.people.set_once({
        $email: user,
        "Sign up date": new Date(),
      });

      Object.keys(props).forEach((key) => {
        mixpanel.people.set_once({
          [key]: props[key],
        });
      });

      getCurrentUserAttr(UserAttrs.SPECIALITY).then((speciality) => {
        mixpanel.people.set_once({
          Speciality: speciality,
        });
      });
    } else {
      mixpanel.identify();
      mixpanel.people.set_once({
        "Sign up date": new Date(),
      });

      Object.keys(props).forEach((key) => {
        mixpanel.people.set_once({
          [key]: props[key],
        });
      });
    }
  }
};

export const setUserAsCompletedSession = (wizardCompletedCount?: number) => {
  if (mixpanel?.people) {
    mixpanel.people.set_once({
      WizardStatus: "WizardCompleted",
    });
    if (wizardCompletedCount) {
      mixpanel.people.set({
        WizardCompletedCount: wizardCompletedCount,
      });
    }
    linkedInWizardCompleted();
  }
};

//linkedin provides a specific src for each conversion
function linkedInWizardCompleted() {
  if (reportLinkedPixel) {
    const element = document.createElement("img");
    element.alt = "";
    element.height = 1;
    element.width = 1;
    element.src =
      "https://px.ads.linkedin.com/collect/?pid=3094378&conversionId=4652329&fmt=gif";
  }
}

export const setUserSpeciality = (speciality: string) => {
  mixpanel.people.set_once({
    Speciality: speciality,
  });
};

// Detects if device is in standalone mode
export const isInStandaloneMode = () =>
  // Check for iOs
  ("standalone" in window.navigator && window.navigator["standalone"]) ||
  // check for android
  window.matchMedia("(display-mode: standalone)").matches;

export const isCordovaApp = () =>
  // @ts-ignore
  !!window.cordova ||
  (document.URL.indexOf("http://") === -1 &&
    document.URL.indexOf("https://") === -1);

export const evt = ({
  category,
  action,
  label,
  value,
  fb,
  addValueToFB,
  partnerId,
  props = {},
}: {
  category: CATEGORY;
  action: ACTION;
  label?: string;
  value?: number;
  fb?: boolean;
  addValueToFB?: boolean;
  partnerId?: string;
  props?: object;
}) => {
  if (action !== ACTION.INIT) {
    if (document.visibilityState === "hidden") return;
    if (document.hidden) return;
  }

  if (_privateMode && !nonPrivateActions.includes(action)) {
    label = label ? "X" : "";
    value = 0;
  }

  const evtAsStr = `${category}: ${action}${
    label && label !== "" ? " - " + label : ""
  }${value ? " " + value : ""}`;

  const inPWA = isInStandaloneMode();
  const isNativeApp = isCordovaApp();
  const isDebug = getFeatureFlags("debugSheet");

  //We reached an event that triggers user creation
  if (
    pendingUserForAnalytics?.mixPanelStartFromEvts.some(
      (e) => e.category === category && e.action === action,
    )
  ) {
    const { user, props } = pendingUserForAnalytics;
    setUserForAnalytics(user, props);
    pendingUserForAnalytics = null;
    pendingEvts.push({ evtAsStr, props });
    //report all events with 0.5 second delay so they appear in mix panel the right order
    //https://community.mixpanel.com/building-analysis-reports-14/flow-report-shows-an-impossible-order-of-events-5290
    pendingEvts.forEach(({ evtAsStr, props }, idx) => {
      setTimeout(
        () =>
          mixpanel.track(evtAsStr, {
            inPWA,
            isNativeApp,
            isDebug,
            ...props,
          }),
        idx * 500,
      );
    });
    pendingEvts = [];
  } else if (pendingUserForAnalytics) {
    //Didn't reach an event to start from, store events for now
    pendingEvts.push({ evtAsStr, props });
  } else {
    try {
      mixpanel.track(evtAsStr, {
        inPWA,
        isNativeApp,
        isDebug,
        partnerId,
        ...props,
      });
    } catch {}
  }

  if (fb && reportFacebookPixel) {
    try {
      // @ts-ignore
      if (window.fbq) {
        // @ts-ignore
        window.fbq(
          "trackCustom",
          `${partnerId ? ` (${partnerId}) ` : ""}${category}-${action} ${
            addValueToFB && value ? value : ""
          } ${addValueToFB && label ? label : ""}`
            .slice(0, 50)
            .trim(),
          {},
        );
      }
    } catch {}
  }

  try {
    if (!isLocal()) {
      ReactGA.event({
        category: category + `${partnerId ? ` (${partnerId}) ` : ""}`,
        action,
        label,
        value,
      });
    }
  } catch {}
};

export function resetAnalytics() {
  try {
    mixpanel.reset();
    setUserForAnalytics();
    // Clear speciality if stored in local storage
    writeToGlobalStorage(UserStorageKey.Speciality, null);
  } catch {}
}
